<template>
  <div
    class="whiteboard"
    :class="{
      ischangearea: isChangeArea,
      packAndChange: isPackUp && isChangeArea,
    }"
  >
    <div class="whiteboard-mian">
      <div class="whiteboard-mid" :style="{right: isChangeArea ? docRight + 'px' : 0}">
        <DocMain
          ref="mainRef"
          v-if="current && liveToken"
          :type="1"
          :current="current"
          @message="onMessage"
        />
        <Blank
          v-else
          :width="isChangeArea ? 90 : 192"
          :btnText="share ? $t('whiteboard.添加白板') : ''"
          :text="share ? $t('whiteboard.也可点击左下角添加白板') : $t('whiteboard.暂无白板')"
          @btnClick="add"
        />
        <slot />
      </div>
      <div class="whiteboard-fix-bottom">
        <slot name="bottom" />
      </div>
    </div>
    <DocTool
      :type="1"
      :docs="docs"
      :page="page"
      :scaleText="scaleText"
      :disabled="shareType === 4"
      @add="add"
      @delThumbs="delThumbs"
      @scalePlus="setZoomPlus"
      @scaleMinus="setZoomMinus"
      @setPage="setPage"
    />
  </div>
</template>

<script>
import DocMain from "@/components/doc/doc.vue";
import Blank from "@/components/blank";
import DocTool from "@/components/doc/doc-tool";
import {
  addWb,
  addPage,
  getWbInfo,
  wbCall,
  delPage,
} from "@/api/docRequest/wb";
import { mapState, mapGetters } from "vuex";
import { getParameter } from "@/utils/global";
import {
  pushRoomMessageFunc,
  removeMessageFunc,
} from "@/utils/socketMessageDispose";
import Role from "@/mixins/role";
import Bus from "@/components/doc/bus";

export default {
  name: "Whiteboard",
  components: {
    DocMain,
    DocTool,
    Blank,
  },
  mixins: [Role],
  data() {
    return {
      roomId: getParameter("roomId"),
      current: undefined,
      docs: undefined,
      page: undefined,
      scale: 1
    };
  },
  computed: {
    ...mapState("docInfo", ["docRight", "isFirstShow"]),
    ...mapGetters([
      "shareType",
      "liveToken",
      "isChangeArea",
      "isPackUp",
      "leftToolType",
    ]),
    scaleText() {
      return Math.ceil((this.scale * 100).toFixed(2));
    },
  },
  watch: {
    liveToken: {
      immediate: true,
      handler(n) {
        if (n) {
          this.getWbInfo();
        }
      },
    },
    leftToolType(n) {
      this.$refs.mainRef?.setMessage("update", [2]);
      if (n === 1 && !this.isFirstShow) {
        this.$store.commit("docInfo/SET_DOC_FIRST_TOOL_SHOW", true)
        this.$refs.mainRef?.setMessage("updateVisibilityToolbar");
      }
    },
    share(n, o) {
      if (o === 0 && n === 1) {
        this.$nextTick(() => {
          if (this.leftToolType === 1) {
            this.setPage(this.page);
          }
        });
      }
    },
  },
  created() {
    Bus.$on('changeDisturb', this.handleChangeDisturb)
  },
  mounted() {
    pushRoomMessageFunc(this.message_event);
  },
  beforeDestroy() {
    removeMessageFunc(this.message_event);
  },
  methods: {
    handleChangeDisturb() {
      this.getWbInfo()
    },
    message_event({ cmd, requestData }) {
      switch (cmd) {
        case 7107:
          this.message_7107(requestData);
          break;
        case 7127:
          this.message_7127(requestData);
          break;
      }
    },
    message_7107(body) {
      if (body.event === "all_white_board_data") {
        const isNotDisturb = this.$store.state.defaultInfo.isNotDisturb
        if(this.share === 0 && isNotDisturb === 'false') return
        this.message_7107_white(body);
      }
    },
    message_7107_white(body) {
      this.$refs.mainRef?.setMessage("setNotice", body);
      switch (body.cmd) {
        case 4071:
          this.current = undefined;
          this.getWbInfo();
          break;
        case 4076:
          if (!this.share) {
            this.$store.commit("SET_LEFTTOOLTYPE", 1);
          }
          break;
      }
    },
    message_7127(body) {
      console.log(" whiteboard control.....")
      switch (body.event) {
        case "assistant_webcast_stream_status":
          if (body.opType !== 3) {
            return;
          }
          console.log('return whiteboard control.....')
          if ([1, 2].includes(body.streamStatus)) {
            this.docs = null;
            this.current = null;
            this.getWbInfo();
          }
          break;
      }
    },
    onMessage(data) {
      if (data.key === "0") return;
      switch (data.event) {
        case "ready":
          this.onReady()
          this.docs = data.data;
          break;
        case "update:doc":
          this.docs = data.data;
          break;
        case "update:page":
          this.page = data.data;
          break;
        case "update:scale":
          this.scale = data.data;
          break;
      }
    },
    setZoomPlus() {
      this.$refs.mainRef.setMessage("setZoomPlus");
    },
    setZoomMinus() {
      this.$refs.mainRef.setMessage("setZoomMinus");
    },
    setPage(page) {
      this.$refs.mainRef.setMessage("slideTo", page);
    },
    // setWhiteDisturb(val) {
    //   console.log('white disturb', val)
    //   // this.$refs.mainRef.setMessage("setLocal", val);
    //   // this.$refs.mainRef.setMessage("setFollow", !val);
    // },
    onReady() {
      if (this.leftToolType === 1) {
        this.$store.commit("docInfo/SET_DOC_FIRST_TOOL_SHOW", true)
      }
    },
    // 获取白板共享信息
    async getWbInfo() {
      const { status, data } = await getWbInfo(this.roomId);
      if (status === 0) {
        if (data.status === 0) {
          if (data.shareStatus === 0) {
            this.current = data;
          } else {
            this.startShare();
          }
        }
      }
    },
    // 新增白板: 当前测试用，真实应该直播间生成默认白板
    async addWb() {
      await addWb(this.roomId);
    },
    // 添加白板页
    async add() {
      await addPage(this.roomId);
    },
    // 开始共享
    async startShare() {
      let params = {
        cmd: 4001,
        roomId: this.roomId,
      };
      await wbCall(params);
    },
    // 结束共享
    async endShare() {
      if (!this.current) return;
      let params = {
        cmd: 4002,
        shareId: this.current.shareId,
      };
      await wbCall(params);
    },
    // 删除白板页
    async delThumbs(item) {
      console.log(item, "item");
      const { page, roomId } = item.page;
      await delPage({
        page,
        roomId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.whiteboard {
  height: 100%;
  padding-bottom: 30px;
  background-color: #131625;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.whiteboard-mian {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.whiteboard-mid {
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.whiteboard-fix-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translateY(calc(100% + 10px));
  transition: all 0.3s ease-in-out;
  transition-delay: 0.3s;
}
.whiteboard-mian:hover {
  .whiteboard-fix-bottom {
    transform: translateY(0);
  }
}
.ischangearea {
  .whiteboard-mid {
    position: fixed;
    top: 40px;
    right: 0px;
    width: 280px;
    height: 158px;
    background-color: #131625;
    z-index: 100;
  }
}
.packAndChange {
  .whiteboard-mid {
    display: none;
  }
}
</style>
